<div class="get-inspired-box__grid">
  @for (trip of activeTrips; track $index) {
    <app-trip-card
      [trip]="trip"
      [showButtonAction]="true"
      [buttonText]="'Explore'"
      [isFetching]="isFetching"
    ></app-trip-card>
  }
</div>
@if (showMorePlacesCount > 0 && !isFetching) {
  <div class="get-inspired-box__more">
    <button type="button" class="orangeLink" (click)="showMore()">
      {{ 'TRIP_PLANNER.SHOW_MORE_POPULAR_TRIPS' | translate }}
    </button>
  </div>
}
